import { useSelector } from "react-redux";

// Custom hook for authorization
export const useAuthorization = () => {
  // Get user permissions from Redux state
  const userPermissions = useSelector((state) => state.user.permissions);

  // Function to check authorization for a specific action on a resource
  const isAuthorized = (resource, action) => {
    if (!userPermissions) {
      return false;
    }
    return userPermissions.some(
      (perm) => perm.action === action && perm.resource === resource
    );
  };

  return { isAuthorized };
};
